import React from "react";
import { NutritionTargetScreen } from "../../fields/NutritionTargetScreen";
import { Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ICheckInQuestionPropsBase } from "./CheckInQuestions";
import { EditorElementView } from "../utils/editorUtils";
import { ClientNutritionCard } from "../../client-nutrition-targets/ClientNutritionCard";
import { useCurrentWorkspace } from "../../../hooks/useCurrentWorkspace";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: "29px",
    color: theme.palette.text.primary,
    marginBottom: 4,
  },

  subtitle: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },

  headerLine: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1.8, 2.3, 1.8, 1.2),
    cursor: "pointer",
    marginBottom: theme.spacing(2),
  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
  },

  createButton: {
    color: theme.palette.secondary.main,
    backgroundColor: "transparent",
    fontSize: 16,
    fontWeight: 600,
    boxShadow: "none",
    height: theme.spacing(4),
    [theme.containerQueries.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },

  headerInfo: {
    marginLeft: theme.spacing(2),
  },

  createButtonIcon: {
    color: theme.palette.primary.main,
    fontSize: "25px!important",
  },

  chevronIcon: {
    transform: "rotate(-90deg)",
  },

  titleLine: {
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
  },

  placeholderContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  placeholderItem: {
    width: "10%",
    height: 20,
    backgroundColor: theme.palette.text.secondary,
    opacity: 0.5,
    borderRadius: 5,
  },
}));

interface ICheckInNutritionTargetProps extends ICheckInQuestionPropsBase<any> {
  handleSetNode: (dataToSet: object) => void;
}
export type CheckInNutritionTargetValue = {};

export const CheckInNutritionTarget = ({
  handleSetNode,
  view,
  disableAnswer,
}: ICheckInNutritionTargetProps) => {
  const s = useStyles();

  const { nutritionsEnabled } = useCurrentWorkspace();

  const handleAddNutrition = () => {
    if (handleSetNode) {
      handleSetNode({
        nutrition: "Nutrition target updated",
      });
    }
  };

  return (
    nutritionsEnabled &&
    (view === EditorElementView.Coach ? (
      <Box>
        <ClientNutritionCard readonly />
      </Box>
    ) : (
      <NutritionTargetScreen
        handleAddNutrition={handleAddNutrition}
        readonly={view !== EditorElementView.Client && disableAnswer}
      />
    ))
  );
};
